import { useApi } from '../../../api/useApi';
import { useContext } from 'react';
import { AuthContext } from '../../../helpers/context_manager/AuthContext';

interface BasicLoginProps {
  username: string;
  password: string;
}

export const useLoginUser = () => {
  const { login, user } = useApi();
  const context = useContext(AuthContext);
  //decide which kind of sign in to use
  //signin user
  //handle errors
  const loginBasic = async (data: BasicLoginProps) => {
    try {
      const response = await login.basicLogin(data);
      await handleResponse(response);
    } catch (e) {
      return handleErrorBasic(e);
    }
  };

  const loginKerberos = async () => {
    try {
      const response = await login.kerberosLogin();
      if(!response.ok) {
        return handleErrorKerberos(response);
      } else {
        const data = await response.json();
        localStorage.setItem('authToken', data.token);

        // Save token to context
        context?.setAuthToken(data.token);
        await loadUser();
      }
    } catch (e) {
      return handleErrorKerberos(e);
    }
  };

  const handleResponse = async (response: any) => {
    //save auth token to local storage
    localStorage.setItem('authToken', response.data.token);
    //add token to authentification token
    context?.setAuthToken(response.data.token);
    //laod user and save to local storage
    await loadUser();
  };

  const loadUser = async () => {
    //laod current user
    const response = await user.getUser();
    //save user to local storage
    localStorage.setItem('user', JSON.stringify(response.data));
  };

  const handleErrorBasic = (error: any) => {
    console.log(error);
    if (error.response.status === 401) {
      console.log('Špatné uživatelské jméno nebo heslo', error.response.statusText);
      return Promise.reject('Špatné uživatelské jméno nebo heslo');
    } else if (error.response.status === 403) {
      console.log('Tento uživatel nemá oprávnění ke vstupu', error.response.statusText);
      return Promise.reject('Tento uživatel nemá oprávnění ke vstupu');
    } else {
      console.log('Chyba při přihlašování uživatele');
      return Promise.reject('Chyba při přihlašování uživatele');
    }
  };

  const handleErrorKerberos = (error: any) => {
    if (error instanceof Response) {
      console.log(`Kerberos login failed with status ${error.status}`);
      console.log('Kerberos login response', error);
      if (error.status === 401) {
        return Promise.reject('Neplatné přihlašovací údaje Kerberos');
      }
      return Promise.reject('Nepodařilo se přihlásit pomocí Kerberos');
    } else {
      console.log('Kerberos login failed', error);
      return Promise.reject('Nepodařilo se přihlásit pomocí Kerberos');
    }
  }

  return { loginBasic, loginKerberos };
};
